import React from 'react'
import { browserHistory } from 'react-router'
import { user } from '../../../core/controllers/user';
import IntegratorTable from '../../../components/Admin/Integrations/IntegratorTable';
import NavLink from '../../../components/Routes/NavLink';

import NewIntegratorsCard from '../../../components/Admin/Integrations/NewIntegratorsCard'
import InactiveIntegratorsCard from '../../../components/Admin/Integrations/InactiveIntegratorsCard'
import ActiveRequestsCard from '../../../components/Admin/Contractors/ActiveRequestsCard'
import TotalIntegratorsCard from '../../../components/Admin/Integrations/TotalIntegratorsCard'

export default class AdminIntegrations extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidUpdate() {
        if (user.userInfo.user_type_alias != 'super-admin') {
            browserHistory.replace('/');
        }
    }

    render(){
        return (
            <div>
                <div class="row">
                    <div class="main-page-header-row col-md-12">
                        <div class="col-md-3">
                            <span class="main-page-header-title">Integrations</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <NewIntegratorsCard clickable={false}/>
                    <InactiveIntegratorsCard clickable={false}/>
                    <ActiveRequestsCard clickable={false}/>
                    <TotalIntegratorsCard clickable={false}/>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="header">
                                <h4 class="title">Integrators</h4>
                                <p class="category">Complete list of all integrators</p>
                            </div>
                            <div class="content">
                                <IntegratorTable />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/Admin/Integrations/AdminIntegrations.jsx